import { API_APP_ID, API_PATHS, buildApiUrl } from "../../config";
import { getAuthorizationHeader } from "../../utils/authToken";
import { createApiClient } from "./createApiClient";

/**
 * CRM player API.
 * Base: {API_BASE_URL}api/v1/player/
 * Requires X-App-Id and Authorization: Bearer <token>.
 */
const playerClient = createApiClient({
  baseURL: buildApiUrl(API_PATHS.PLAYER),
  headers: {
    "X-App-Id": API_APP_ID,
  },
});

playerClient.interceptors.request.use((config) => {
  const authorization = getAuthorizationHeader();
  if (authorization) {
    config.headers.Authorization = authorization;
  }
  return config;
});

export default playerClient;
